import { useLocalStorage } from "@medoma/shared-employee/useLocalStorage";
import { useUserProfile } from "@/api/Users";

export const useActivitiesViewToolbar = () => {
  const { userId } = useUserProfile();

  // "Me" resolves to whoever is signed in, so the toggle has to follow them:
  // inherited from a previous employee it filters the list down to somebody
  // else's activities while still reading as the full list.
  const [storedShowOnlyAssignedToMe, setStoredShowOnlyAssignedToMe] =
    useLocalStorage({
      key: "activities.showOnlyAssignedToMe",
      userId,
      initialValue: "false",
    });

  const showOnlyAssignedToMe = storedShowOnlyAssignedToMe === "true";

  const setShowOnlyAssignedToMe = (value: boolean) => {
    setStoredShowOnlyAssignedToMe(value ? "true" : "false");
  };

  const [storedExpandedRowLayout, setStoredExpandedRowLayout] = useLocalStorage(
    {
      key: "activities.expandedRowLayout",
      userId,
      initialValue: "false",
    },
  );

  const expandedRowLayout = storedExpandedRowLayout === "true";

  const setExpandedRowLayout = (value: boolean) => {
    setStoredExpandedRowLayout(value ? "true" : "false");
  };

  return {
    showOnlyAssignedToMe,
    setShowOnlyAssignedToMe,
    expandedRowLayout,
    setExpandedRowLayout,
  };
};
